import { render, staticRenderFns } from "./ProjectArea.vue?vue&type=template&id=51445176&scoped=true&lang=pug&"
import script from "./ProjectArea.vue?vue&type=script&lang=js&"
export * from "./ProjectArea.vue?vue&type=script&lang=js&"
import style0 from "./ProjectArea.vue?vue&type=style&index=0&id=51445176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51445176",
  null
  
)

export default component.exports